import { useCallback, useState } from 'react'

export default function useTheForce() {
  const [count, setCount] = useState(0)

  return useCallback(() => {
    setCount(count + 1)
  }, [count])
}
